import styled from "styled-components";
import { themeGet } from "styled-system";

const StyledForm = styled.div`
  color: white;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  a {
    color: white;
    text-decoration: underline;
  }
  label {
    font-size: 0.875rem;
    color: white;
    margin-bottom: 0.5rem;
    margin-top: 1.5rem;
    display: block;
  }
  select {
    height: 54px;
    color: white;
    width: 100%;
    background: #3b378d;
    border: 2px solid ${props => (props.error ? "#ff7351" : "#7572ba")};
  }
  input[type="text"],
  input[type="email"],
  input[type="password"] {
    margin-bottom: 0.5rem;
    color: white;
    display: block;
    border: 2px solid ${props => (props.error ? "#ff7351" : "#7572ba")};
    border-radius: 4px;
    padding: 1rem;
    font-size: 1rem;
    width: 100%;
    background: #3b378d;
    background-clip: padding-box;
  }
  fieldset {
    border: 0;
  }
`;
export default StyledForm;
